import Icon from '../../../components/AppIcon';

const WorkflowStageCard = ({ stage, onClick }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-success/10 text-success border-success/20';
      case 'active':
        return 'bg-primary/10 text-primary border-primary/20';
      case 'pending':
        return 'bg-muted/10 text-muted-foreground border-muted/20';
      case 'delayed':
        return 'bg-error/10 text-error border-error/20';
      default:
        return 'bg-muted/10 text-muted-foreground border-muted/20';
    }
  };

  const getColorClasses = (color) => {
    switch (color) {
      case 'primary':
        return 'bg-primary/10 text-primary';
      case 'success':
        return 'bg-success/10 text-success';
      case 'warning':
        return 'bg-warning/10 text-warning';
      case 'error':
        return 'bg-error/10 text-error';
      case 'accent':
        return 'bg-accent/10 text-accent';
      case 'secondary':
        return 'bg-secondary/10 text-secondary';
      default:
        return 'bg-primary/10 text-primary';
    }
  };

  return (
    <div
      onClick={onClick}
      className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all duration-300 cursor-pointer group"
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className={`p-3 rounded-lg ${getColorClasses(stage?.color)}`}>
          <Icon name={stage?.icon} size={24} />
        </div>
        <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getStatusColor(stage?.status)}`}>
          {stage?.status?.charAt(0)?.toUpperCase() + stage?.status?.slice(1)}
        </span>
      </div>

      {/* Stage Name */}
      <h3 className="text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
        {stage?.name}
      </h3>

      {/* Timing */}
      <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
        <Icon name="Clock" size={14} />
        <span>{stage?.timing}</span>
      </div>

      {/* Progress Bar */}
      {stage?.status === 'active' && (
        <div className="mb-4">
          <div className="flex items-center justify-between text-xs text-muted-foreground mb-1">
            <span>Progress</span>
            <span>{stage?.progress}%</span>
          </div>
          <div className="w-full bg-muted/20 rounded-full h-2">
            <div
              className="bg-primary h-2 rounded-full transition-all duration-300"
              style={{ width: `${stage?.progress}%` }}
            />
          </div>
        </div>
      )}

      {/* Objectives Preview */}
      <p className="text-sm text-muted-foreground line-clamp-2 mb-4">
        {stage?.objectives}
      </p>

      {/* Contacts Count */}
      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Users" size={14} />
          <span>{stage?.contacts?.length} contacts</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="CheckSquare" size={14} />
          <span>{stage?.requiredOutputs?.length} outputs</span>
        </div>
      </div>

      {/* Dates */}
      {stage?.status === 'completed' && stage?.completedDate && (
        <div className="mt-3 flex items-center gap-2 text-xs text-success">
          <Icon name="CheckCircle" size={12} />
          <span>Completed on {new Date(stage?.completedDate)?.toLocaleDateString()}</span>
        </div>
      )}

      {stage?.status === 'active' && stage?.expectedCompletion && (
        <div className="mt-3 flex items-center gap-2 text-xs text-primary">
          <Icon name="Calendar" size={12} />
          <span>Due: {new Date(stage?.expectedCompletion)?.toLocaleDateString()}</span>
        </div>
      )}

      {stage?.status === 'pending' && stage?.expectedStart && (
        <div className="mt-3 flex items-center gap-2 text-xs text-muted-foreground">
          <Icon name="Calendar" size={12} />
          <span>Starts: {new Date(stage?.expectedStart)?.toLocaleDateString()}</span>
        </div>
      )}
    </div>
  );
};

export default WorkflowStageCard;